module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "province-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "ctrlsBar"
  }, [_c('el-menu', {
    staticClass: "menuButton",
    attrs: {
      "mode": "horizontal",
      "background-color": "#409EFF",
      "text-color": "#fff",
      "active-text-color": "fff"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-submenu', {
    attrs: {
      "show-timeout": 0,
      "hide-timeout": 0,
      "index": "2"
    }
  }, [_c('template', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("批量审核")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_vm._v("退回")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "21"
    }
  }, [_vm._v("暂缓登记")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "13"
    }
  }, [_vm._v("注销或拟注销")])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "tips"
  }, [_vm._v("（若省局已经审核完成，请点击“上报国家新闻出版署”。）")]), _vm._v(" "), _c('div', {
    staticClass: "blockRt"
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.postDat.status),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "status", $$v)
      },
      expression: "postDat.status"
    }
  }, _vm._l((_vm.typeArr), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "通过单位名称查询"
    },
    model: {
      value: (_vm.postDat.keyword),
      callback: function($$v) {
        _vm.$set(_vm.postDat, "keyword", $$v)
      },
      expression: "postDat.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tabDats,
      "border": ""
    },
    on: {
      "selection-change": _vm.selectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "selectable": _vm.checkDfine,
      "type": "selection",
      "width": "45",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "60",
      "align": "center",
      "type": "index"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.$index + 1 + 15 * (_vm.postDat.no - 1)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organizationName",
      "label": "出版单位",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "180",
      "label": "查阅时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row.sjViewDate, "time")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "省局意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "sjstatus")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "国家新闻出版署意见",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("transZjStr")(scope.row, "statuszj")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          class: _vm.styleTrans(scope.row.status)
        }, [_vm._v(_vm._s(_vm._f("transStr")(scope.row, "state")))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "90",
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0 || scope.row.progress == '省局') ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 1)
            }
          }
        }, [_vm._v("审核")]) : _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.goFirm(scope.row, 2)
            }
          }
        }, [_vm._v("查看 ")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.postDat.total > 1) ? _c('div', {
    staticClass: "pageCage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.postDat.no,
      "layout": "prev, pager, next",
      "page-count": _vm.postDat.total
    },
    on: {
      "current-change": _vm.pageSent
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "pg3_1dig",
    attrs: {
      "visible": _vm.backdiag,
      "modal": true,
      "close-on-click-modal": false,
      "width": "450px"
    },
    on: {
      "update:visible": function($event) {
        _vm.backdiag = $event
      },
      "close": _vm.handleClose
    }
  }, [(_vm.backtype == 3) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 3) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 21) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 21) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.message),
      callback: function($$v) {
        _vm.$set(_vm.params, "message", $$v)
      },
      expression: "params.message"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 12) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 12) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.zanhuanMessage),
      callback: function($$v) {
        _vm.$set(_vm.params, "zanhuanMessage", $$v)
      },
      expression: "params.zanhuanMessage"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 13) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 13) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.zhuxiaoMessage),
      callback: function($$v) {
        _vm.$set(_vm.params, "zhuxiaoMessage", $$v)
      },
      expression: "params.zhuxiaoMessage"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.backtype == 14) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入意见")]) : _vm._e(), _vm._v(" "), (_vm.backtype == 14) ? _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.params.chexiaoMessage),
      callback: function($$v) {
        _vm.$set(_vm.params, "chexiaoMessage", $$v)
      },
      expression: "params.chexiaoMessage"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.arrExam
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v("电子出版物出版单位审核")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1fb83fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/provinceRole/electPgress/electList.vue
// module id = 1798
// module chunks = 1